import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES } from '../../core/constats';
import { bonusPadMobileDrawer } from './drawers/BonusPadMobileDrawer';
import { GAME_MODE } from '../../stateManagment/gameState';
import { BonusPadDesktopDrawer } from './drawers/BonusPadDesktopDrawer';
import { bonusWheelDrawer } from '../wheel/WheelDrawer';

class BonusPadDrawer extends BaseParentControlDrawer {
  setWheelCrystals(elements = bonusWheelDrawer.containerAndWheel) {
    return this.applications[GAME_MODE.getValue()].setWheelCrystals(elements);
  }
}

export const bonusPadDrawer = new BonusPadDrawer({
  [GAME_MODES.MOBILE]: bonusPadMobileDrawer,
  [GAME_MODES.DESKTOP]: new BonusPadDesktopDrawer(),
});
